import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Pencil } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const FIELDS = [
  ['parcels_delivered', 'Delivered', 'delivered'],
  ['parcels_collected', 'Collected', 'collections'],
  ['parcels_returned', 'Returned', 'returned'],
  ['kilometres', 'KM', 'kilometres'],
];

export default function EditDayDialog({ driverId, row, onSaved }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const openDialog = () => { setForm(Object.fromEntries(FIELDS.map(([k, , src]) => [k, row[src] ?? 0]))); setOpen(true); };

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/driver-trips`, { driver_id: driverId, date: row.date, ...form });
      toast.success(`Updated ${row.date}`);
      setOpen(false);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
    finally { setSaving(false); }
  };

  return (
    <>
      <Button size="sm" variant="outline" className="h-8 w-8 p-0" onClick={openDialog} data-testid={`edit-day-${row.date}`}>
        <Pencil className="h-3.5 w-3.5" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="edit-day-dialog">
          <DialogHeader>
            <DialogTitle>Edit totals — {row.date}</DialogTitle>
            <DialogDescription>Correct the driver's figures. Stops and Perf % recalculate automatically.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            {FIELDS.map(([k, label]) => (
              <div key={k}>
                <Label className="text-xs">{label}</Label>
                <Input type="number" min="0" step={k === 'kilometres' ? '0.1' : '1'} value={form[k]}
                  onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} data-testid={`edit-day-${k}`} />
              </div>
            ))}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="edit-day-cancel">Cancel</Button>
            <Button onClick={save} disabled={saving} data-testid="edit-day-save">{saving ? 'Saving…' : 'Save'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
